import { render, staticRenderFns } from "./UserMenuAdd.vue?vue&type=template&id=30f38942&scoped=true&"
import script from "./UserMenuAdd.vue?vue&type=script&lang=js&"
export * from "./UserMenuAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f38942",
  null
  
)

export default component.exports